import styled from 'styled-components';

import { useButtonGroupContext } from './ButtonGroupContext';

import type { BaseButtonItem } from './model';

function ButtonGroup() {
  const { buttonGroup } = useButtonGroupContext();

  if (buttonGroup.length === 0) {
    console.warn('ButtonGroupProvider must have more than one tab item');
    return null; // ButtonGroupProvider must have children
  }

  return (
    <SButtonGroup>
      {buttonGroup.map((tab) => (
        <ButtonItem key={tab.type} tab={tab} />
      ))}
    </SButtonGroup>
  );
}

const SButtonGroup = styled.ul`
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

type ButtonItemProps = {
  tab: BaseButtonItem;
};

function ButtonItem({ tab }: ButtonItemProps) {
  const { activateButtonItem, onButtonClick } = useButtonGroupContext();
  const handleActivateItem = () => onButtonClick(tab.type);

  const isActive = activateButtonItem?.type === tab.type;

  return (
    <li>
      <SButton onClick={handleActivateItem} $isActive={isActive}>
        <SButtonText $isActive={isActive}>{tab.label}</SButtonText>
      </SButton>
    </li>
  );
}

type SButtonProps = {
  $isActive: boolean;
};
const SButton = styled.button<SButtonProps>`
  padding: 6px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  background-color: ${({ theme, $isActive }) => ($isActive ? theme.palette.neutral[55] : theme.palette.neutral[15])};

  @media ${({ theme }) => theme.device.large} {
    padding: 6px 10px;
  }
`;

// TODO: 텍스트 중앙 정렬 확인
type SButtonTextProps = {
  $isActive: boolean;
};
const SButtonText = styled.p<SButtonTextProps>`
  ${({ theme }) => theme.font.body1_sb};
  color: ${({ theme, $isActive }) => ($isActive ? theme.palette.common.white : theme.palette.common.black)};
  text-align: center;
  display: flex;
  align-items: center;

  @media ${({ theme }) => theme.device.large} {
    ${({ theme }) => theme.font.caption2_sb};
  }
`;

export default ButtonGroup;
